import styled, { css } from 'styled-components';
import { Column } from '@simplywallst/ui-core';
import { media } from '@simplywallst/ui-core';

const spacing = css`
  > div {
    position: relative;
    margin: 0 8px;
  }
  &:first-child {
    > div {
      margin-left: 0;
    }
  }
  &:last-child {
    > div {
      margin-right: 0;
    }
  }
`;

export const Title = styled('h4')`
  ${({ theme }) => theme.typography.baseStrong}
  text-transform: capitalize;
  color: ${({ theme }) => theme.color.white};
`;

interface WrapperProps {
  canStack?: boolean;
}

export const Wrapper = styled(Column)<WrapperProps>`
  ${({ canStack }) => !canStack && spacing}
  ${media.mdUp`
    ${spacing}
  `};
`;

export const Chart = styled('div')`
  position: relative;
  z-index: 1;
  padding: 0 ${({ theme }) => theme.x1spacePx}px;
  border-bottom: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.2)};
  > svg {
    display: block;
  }
`;

export const Axis = styled('div')`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  > svg {
    display: block;
  }
`;
